import React from 'react';
import { isRouteErrorResponse, useRouteError } from 'react-router-dom';

export default function ErrorPage(): React.ReactElement {
  const error = useRouteError();
  let title = 'Une erreur est survenue';
  let message = 'Désolé, une erreur inattendue s’est produite.';
  let details: string | undefined;

  if (isRouteErrorResponse(error)) {
    title = `Erreur ${error.status}`;
    message = error.statusText || message;
    details = typeof error.data === 'string' ? error.data : undefined;
  } else if (error instanceof Error) {
    details = error.message;
  }

  return (
    <div className="min-h-screen flex items-center justify-center p-6">
      <div className="w-full max-w-lg rounded-lg border bg-white p-6 shadow-sm">
        <h1 className="text-xl font-semibold text-red-600 mb-2">{title}</h1>
        <p className="text-sm text-gray-700 mb-4">{message}</p>
        {details ? (
          <pre className="text-xs text-gray-500 overflow-auto max-h-48 bg-gray-50 p-2 rounded">{details}</pre>
        ) : null}
        <div className="mt-4 flex gap-2">
          <button className="px-3 py-2 rounded bg-gray-100 hover:bg-gray-200 text-sm" onClick={() => history.back()}>
            Retour
          </button>
          <button className="px-3 py-2 rounded bg-blue-600 hover:bg-blue-700 text-white text-sm" onClick={() => window.location.reload()}>
            Recharger la page
          </button>
        </div>
      </div>
    </div>
  );
}


